import { QuickFrameError, type QuickFrameErrorOptions } from '@mntn-dev/errors'

import type { FlagTag } from './flag-definitions.ts'

export class FeatureFlagError extends QuickFrameError<FlagTag> {
  constructor(
    code: FlagTag,
    message: string,
    options: Partial<QuickFrameErrorOptions<FlagTag>> = {}
  ) {
    super(message, { code, ...options })
  }
}
